<template>
  <fin-portfolio-value :hide-hint="forceShowHint !== true && (diff === 0 || diff === null)" :hint="hint" :title="title">
    <template #actions>
      <slot name="portfolioActions"/>
    </template>

    <template #valueLine v-if="!hideValueLine">
      <span v-if="addSign"
            :style="{color: color ? color : (to < 0 ? $finColors.accentRed : $finColors.accentGreen)}">
        {{ to | currencyChange }}
      </span>
      <span v-if="cash"
            :style="{color: color ? color : (to < 0 ? $finColors.accentRed : $finColors.primaryDark)}">
        {{ to | finCurrency | isNaN }}
      </span>
      <span :style="{color: color ? color : (to < 0 ? $finColors.accentRed : $finColors.accentGreen)}"
            v-else>
        {{ to | finCurrency | isNaN }}
      </span>
      <fin-time-ago v-if="valueDate" :datetime="valueDate" :prepend-text="valueDatePrefix" class="mb-4"
                    style="display: block"/>
    </template>

    <template #valueSubline v-if="diff">
      <span :style="{color: diff < 0 ? $finColors.accentRed : $finColors.accentGreen}">
        {{ diff | currencyChange | isNaN }} ({{ change | percent | isNaN }})
      </span>
    </template>

    <template v-if="hint || $scopedSlots.portfolioHint" #hint>
      <slot name="portfolioHint"/>
    </template>

    <template #buttons>
      <slot name="actionsButtons"/>
    </template>
  </fin-portfolio-value>
</template>

<script>
import FinPortfolioValue from '@/components/pages/myPortfolio/PortfolioValue'

export default {
  name: 'finPortfolioValueChange',
  components: {FinPortfolioValue},
  props: {
    title: {
      type: String
    },
    hint: {
      type: String
    },
    forceShowHint: {
      type: Boolean,
      default: false
    },
    from: {
      type: Number
    },
    to: {
      type: [Number, String],
      default: 'NaN',
      required: true
    },
    valueDate: {
      type: [Date, String, Number]
    },
    valueDatePrefix: {
      type: String,
      default: undefined
    },
    hideValueLine: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    },
    addSign: {
      type: Boolean,
      default: true
    },
    cash: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    diff() {
      return this.from ? Number(this.to.toFixed(4)) - Number(this.from.toFixed(4)) : null
    },
    change() {
      return this.from ? 100 / Number(this.from.toFixed(4)) * this.diff : null
    }
  }
}
</script>

<style scoped>

</style>
